<script>

import Header from "@/components/Header.vue";
import ListControls from "@/components/listControls.vue";
import {ListLogicMixin} from '@/assets/js/mixins/list-logic-mixin';
import _ from "lodash";
import axios from "axios";

export default {
  name: "LogList",
  components: {ListControls, Header},
  mixins: [ListLogicMixin],
  data: () => {
    return {
      apiList: "/api/log/list",
      apiUrl: '/api/log/',
      items: [],
      limit: localStorage.getItem('LogLimit') ?? "100",
      filterExact: [],
      textareaData: '',
      filterValues: {
        'Action': null,
        'Entity': null,
        'UserId': null,
        'Data': null,
        'UserRole': null,
      },
      itemsSelectedCount: 0,
      allSelected: false,
      filterOptions: {
        'Action': {
          'options': [
            {
              "value": null,
              "label": "ANY"
            }
          ],
          'uri': 'api/log/list?group=Action',
          'labelField': 'Action',
          'valueField': 'Action'
        },
        'Entity': {
          'options': [
            {
              "value": null,
              "label": "ANY"
            }
          ],
          'uri': '/api/log/list?group=Entity',
          'labelField': 'Entity',
          'valueField': 'Entity'
        },

      }
    }
  },
  created() {
    this.loadOptions()
  },
  methods: {
    ChangeLimit(newLimit) {
      this.limit = newLimit;
      localStorage.setItem('LogLimit', newLimit);
      this.LoadData();
    },
    filterChanged() {
      this.filterSend()
    },
    loadOptions: async function () {
      await _.forOwn(this.filterOptions, (value, key) => {
        if (value.uri && key !== 'UsedBy') {
          this.filterOptions[key].options = this.getOptions(value.labelField, value.valueField, value.uri, key, this.filterOptions[key].options)
        }
      })
      this.filterPreparing();
      this.filterQuery();
      this.LoadData();
    },
    getOptions: function (labelField, valueField, query, key, currentOptions = []) {
      const options = currentOptions
      axios.post(query, [], this.authRespConf())
          .then(res => {
            if (res === undefined || res === null) {
              return []
            }
            if (res.data.data !== undefined) {
              for (let dataIndex in res.data.data) {
                options.push({
                  value: res.data.data[dataIndex][valueField],
                  label: key.toLowerCase() === 'state' ? this.getStateOptionLabel(res.data.data[dataIndex][labelField]) : res.data.data[dataIndex][labelField],
                });
              }
            }
          });
      return options;
    },
    filterSend() {
      let currentQuery = this.$route.query;
      let newFilters = [];
      for (let FieldName in this.filterValues) {
        if (this.filterValues[FieldName] !== '') {
          let data = {};
          data[FieldName] = this.filterValues[FieldName];
          if (data[FieldName] !== null) {
            if (this.filterExact.includes(FieldName)) {
              newFilters.push({
                Condition: "=",
                Data: data,
              });
            } else {
              newFilters.push({
                Condition: "ilike",
                Data: data,
              });
            }
          }
        }
      }
      if (JSON.stringify(currentQuery) !== JSON.stringify({filter: JSON.stringify(newFilters)})) {
        this.$router.push({query: {filter: JSON.stringify(newFilters)}});
        this.filters = newFilters;
        this.LoadData()
      } else {
        console.log('Filter error: filter duplicate')
      }
    },
    openDeleteItemConfirmation(item) {
      this.confirmModalTitle = 'Confirm delete Log: ' + item.Id;
      this.currentItemId = parseInt(item.Id);
      this.$modal.show('confirmItemDelete');
    },
    selectAll: function () {
      this.selectedItemsList = [];
      this.itemsSelectedCount = 0
      if (this.allSelected) {
        let index;
        for (index in this.items) {
          this.selectedItemsList.push(this.items[index].Id);
          this.itemsSelectedCount++
        }
      }
    },
    clearFilter() {
      for (let FieldName in this.filterValues) {
        this.filterValues[FieldName] = '';
      }
      this.filters = [];
      this.queryFilter = [];
      this.$route.query.filter;
      this.filterChanged();
    },
    actionDelete() {
      this.confirmModalTitle = 'Confirm delete Log';
      this.confirmModalMsg =
          'Are you sure you want to delete ' +
          document.getElementsByClassName('selected').length +
          ' logs?';
      this.$modal.show('confirm');
    },
    closeEditModal() {
      this.currentItemId = null;
      this.LoadData()
    },
    showLog(data) {
      this.textareaData = data;
      this.$modal.show('modalLog')
    }
  },
  watch: {
    selectedItemsList(val) {
      this.itemsSelectedCount = val.length
      if (this.itemsSelectedCount === 0) {
        this.allSelected = false
      }
    },
  }
}
</script>

<template>
  <div class="page">
    <Header
        title="Logs"
    />
    <div class="container dashboard card">
      <div class="card-header">
        <span class="other-buttons">
          <button @click="downloadTable()" class="btn btn-primary">
            <i class="fa fa-download"></i>
          </button>
        </span>
      </div>
      <div class="card-body">
        <div v-bind:class="loading"></div>
        <table class="table table-responsive-sm" id="resizable-table">
          <thead>
          <tr>
            <th>
              <span class="col-text cursor-pointer" @click="SortInvert('Id')">ID</span>
              <span class="icon-up" v-show="sortField === 'Id'"><b-icon icon="arrow-up"></b-icon></span>
              <span class="icon-up" v-show="sortField === 'Id'"><b-icon icon="arrow-down"></b-icon></span>
            </th>
            <th style="width: 8rem;">
              <span class="col-text cursor-pointer" @click="SortInvert('Action')">Action</span>
              <span class="icon-up" v-show="sortField === 'State'"><b-icon icon="arrow-up"></b-icon></span>
              <span class="icon-up" v-show="sortField === 'State'"><b-icon icon="arrow-down"></b-icon></span>
            </th>
            <th style="width: 8rem;">
              <span class="col-text cursor-pointer" @click="SortInvert('Entity')">Entity</span>
              <span class="icon-up" v-show="sortField === 'State'"><b-icon icon="arrow-up"></b-icon></span>
              <span class="icon-up" v-show="sortField === 'State'"><b-icon icon="arrow-down"></b-icon></span>
            </th>
            <th style="width: 8rem;">
              <span class="col-text cursor-pointer" @click="SortInvert('UserId')">User</span>
              <span class="icon-up" v-show="sortField === 'State'"><b-icon icon="arrow-up"></b-icon></span>
              <span class="icon-up" v-show="sortField === 'State'"><b-icon icon="arrow-down"></b-icon></span>
            </th>
            <th style="width: 8rem;">
              <span class="col-text cursor-pointer" @click="SortInvert('Created')">Created</span>
              <span class="icon-up" v-show="sortField === 'State'"><b-icon icon="arrow-up"></b-icon></span>
              <span class="icon-up" v-show="sortField === 'State'"><b-icon icon="arrow-down"></b-icon></span>
            </th>
            <th>
              <span class="col-text cursor-pointer" @click="SortInvert('Data')">Data</span>
              <span class="icon-up" v-show="sortField === 'Address'"><b-icon icon="arrow-up"></b-icon></span>
              <span class="icon-up" v-show="sortField === 'Address'"><b-icon icon="arrow-down"></b-icon></span>
            </th>
            <th/>
            <th scope="col" class="text-center">
              <b-checkbox
                  @change="selectAll()"
                  v-model="allSelected"
              ></b-checkbox>
            </th>
          </tr>
          <tr @keyup.enter="filterChanged">
            <th/>
            <th>
              <b-form-select
                  :options="filterOptions.Action.options"
                  text-field="label"
                  value-field="value"
                  @change="filterChanged"
                  v-model="filterValues.Action"
                  placeholder="Action"
                  inputId="action"
                  required
                  clearable/>
            </th>
            <th>
              <b-form-select
                  :options="filterOptions.Entity.options"
                  text-field="label"
                  value-field="value"
                  @change="filterChanged"
                  v-model="filterValues.Entity"
                  placeholder="Entity"
                  inputId="entity"
                  required
                  clearable/>
            </th>
            <th>
              <b-input-group>
                <b-form-input v-model="filterValues.UserId" placeholder="User ID"></b-form-input>
                <b-input-group-append is-text>
                  <input type="checkbox" v-model="filterExact" value="UserId" content="Exact phrase"
                         v-tippy="{arrow : true}" aria-label="Exact phrase">
                </b-input-group-append>
              </b-input-group>
            </th>
            <th/>
            <th>
              <b-input-group>
                <b-form-input v-model="filterValues.Data" placeholder="Data"></b-form-input>
                <b-input-group-append is-text>
                  <input type="checkbox" v-model="filterExact" value="Data" content="Exact phrase"
                         v-tippy="{arrow : true}" aria-label="Exact phrase">
                </b-input-group-append>
              </b-input-group>
            </th>
            <th>
            <span class="cel-buttons">
              <span class="icon-search" @click="filterChanged()" title="Apply filters"><i
                  class="fa fa-solid fa-search"></i></span>
               <span class="icon-clear" @click="clearFilter()" title="Clear filters">
                <font-awesome-icon icon="recycle" class="icon alt"/>
               </span>
            </span>
            </th>
            <th/>
          </tr>
          </thead>
          <tbody>
          <tr
              v-for="item in items"
              v-bind:key="item.id"
              @click="rowClick(item, $event)"
              :data-item-id="item.Id"
              :id="'item' + item.Id"
              :class="{'selected':selectedItemsList.indexOf(item.Id) >= 0}"
          >
            <td>
              <span class="cel-text">{{ item.Id }}</span>
            </td>
            <td>
              <span class="cel-text">{{ item.Action }}</span>
            </td>
            <td>
              <span class="cel-text">{{ item.Entity }}</span>
            </td>
            <td>
              <span class="cel-text">{{ item.UserRole }}[{{ item.UserId }}]</span>
            </td>
            <td>
              <span class="cel-text">{{ item.Created }}</span>
            </td>
            <td>
              <span v-if="item.Data.length > 0" class="cel-text">{{ String(item.Data).substring(0, 200) }}<span v-if="item.Data.length > 200">...<br/><span class='table-show-more'
                                                                                            data-field='Data'
                                                                                            @click="showLog(item.data)">Show more</span></span></span>
              <span v-else>EMPTY</span>
            </td>
            <td>
              <span class="cel-buttons">
                <button style="display: none" class="btn btn-as-link icon-only" @click="editItem(item)"><i class="fa fa-pencil"></i></button>
                <button class="btn btn-as-link icon-only  text-danger" @click="openDeleteItemConfirmation(item)"><i
                    class="fa fa-trash"></i></button>
              </span>
            </td>
            <td class="text-center">
              <b-checkbox
                  v-model="selectedItemsList"
                  :value="item.Id"
              ></b-checkbox>
            </td>
          </tr>
          </tbody>
        </table>
        <p class="text-center" v-if="items?.length === 0">Nothing found</p>
        <ListControls
            v-else
            v-on:onLimitChanged="ChangeLimit"
            :total="total"
            :default-limit="limit"
            :options="[
                {value: '10',text: '10'},
                {value: '50',text: '50'},
                {value: '100',text: '100'},
                {value: '500',text: '500'},
                {value: '1000',text: '1000'},
            ]"
        />
      </div>
    </div>
    <ModalConfirmItemDelete
        v-on:onComplete="deletedItem"
        v-on:onError="deletedItemErr"
        :title="confirmModalTitle"
        :url="apiUrl"
        :itemId="currentItemId"
    />
    <ModalConfirm
        :msg="confirmModalMsg"
        :title="confirmModalTitle"
        v-on:onModalСonfirmEvent="modalConfirmEvent"/>
    <ModalLog :data="textareaData" :modalName="'modalLog'"/>
  </div>
</template>

<style scoped>

</style>